import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { clearUser, fetchUser } from './../../redux/userSlice';
import Header_User from './../user/Header_User';
import Header_Cart from './../cart/Header_Cart';
import { Link } from 'react-router-dom';
import { AiOutlineShoppingCart, AiOutlineQuestionCircle, AiOutlineHome, AiOutlineMenu } from 'react-icons/ai';
import { BiBook } from 'react-icons/bi';
import './header.css';

const NAV_LINKS = [
  {
    app: null, // toujours visible
    to: "/",
    icon: <AiOutlineHome size={30} title="Accueil" />,
    label: "Accueil"
  },
  {
    app: "catalog",
    to: "/catalog",
    icon: <BiBook size={30} title="Catalogue" />,
    label: "Catalogue"
  },
  {
    app: "orders",
    to: "/orders",
    icon: <AiOutlineShoppingCart size={30} title="Accéder aux commandes" />,
    label: "Commandes"
  },
  {
    app: "faq",
    to: "/faq",
    icon: <AiOutlineQuestionCircle size={30} title="Accéder à la FAQ" />,
    label: "FAQ/Forum"
  }
];
const Header = React.memo(() => {
  const user = useSelector((state) => state.user);
  const tenant = useSelector((state) => state.config.tenant);





  const { t } = useTranslation();

  const logo = tenant?.front?.logo ?? '/img/logo.png';
  const phoneNumber = tenant?.front?.phone_number;
  const enabledApps = tenant?.front?.apps ?? [];



  const navLinks = NAV_LINKS.filter(link =>
    link.app === null || enabledApps.includes(link.app)
  );

  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(prev => !prev);

  return (
    <header className={`App-header ${menuOpen ? 'responsive-menu-on' : ''}`} id="app-header">
      <div id="header-main">

        <div id='header-main-left'>
          {user.isSignedIn && (
            <Link className='logo' to="/">
              <img src={logo} alt='logo' />
            </Link>
          )}
        </div>

        {user.isSignedIn ? (
          <div id='header-main-center'>
            <nav className={`nav-links ${menuOpen ? 'active' : ''}`}>
              {navLinks.map((link) => (
                <Link to={link.to} className="btn btn-brand-primary" key={link.to}>
                  {link.icon}
                  <span>{link.label}</span>
                </Link>
              ))}
            </nav>
          </div>
        ) : (
          <div id='header-main-center' className="text-center">
            <span className="logo">
              <img src={logo} alt='logo' />
            </span>
          </div>
        )}

        <div id='header-main-right'>
          {phoneNumber && (
            <div className='fw-bold mb-1 fs-6 text-gray-9'>{phoneNumber}</div>
          )}
          <div className='right-modules'>
            {user.isSignedIn && (
              <>
                <Header_User />
                <Header_Cart />
              </>
            )}
          </div>
        </div>

      </div>

      <button className="burger-menu" onClick={toggleMenu}>
        <AiOutlineMenu size={30} />
      </button>

      <div id="header-responsive-menu">
        <ul className="list-unstyled ">
          {navLinks.map((item) => (
            <li className="py-2" key={item.to}>
              <Link to={item.to} onClick={() => setMenuOpen(false)}>
                {item.label}
              </Link>
            </li>
          ))}
          <li><hr /></li>
          {user.isSignedIn && (
            <li className='d-flex buttons'>      <Header_User /><Header_Cart /></li>
          )}
        </ul>
      </div>

    </header>
  );
});

export default Header;